import React from 'react';
import Text from '@/components/Text';
import { SlideProps } from './slideTypes';
import { SLIDE_COMPONENT_TEXT_SIZE, SLIDE_COMPONENT_TITLE_SIZE } from './slideConstants';

export function SwotSlide({ slide }: SlideProps) {
  const swotData = slide.data?.content || slide.data || {};
  
  const toArray = (value: any): string[] => {
    if (Array.isArray(value)) {
      return value.filter(item => item != null && String(item).trim().length > 0).map(item => String(item));
    }
    if (value != null && typeof value === 'string' && value.trim().length > 0) return [value];
    return [];
  };
  
  const getValue = (key: string): any => {
    if (swotData[key]) return swotData[key];
    const capitalizedKey = key.charAt(0).toUpperCase() + key.slice(1);
    if (swotData[capitalizedKey]) return swotData[capitalizedKey];
    if (swotData[key.toUpperCase()]) return swotData[key.toUpperCase()];
    return undefined;
  };
  
  const sections = [
    { title: 'Strengths', items: toArray(getValue('strengths')), color: 'bg-green-500/20 text-green-400 border-green-500/30' },
    { title: 'Weaknesses', items: toArray(getValue('weaknesses')), color: 'bg-red-500/20 text-red-400 border-red-500/30' },
    { title: 'Opportunities', items: toArray(getValue('opportunities')), color: 'bg-blue-500/20 text-blue-400 border-blue-500/30' },
    { title: 'Threats', items: toArray(getValue('threats')), color: 'bg-orange-500/20 text-orange-400 border-orange-500/30' },
  ];

  return (
    <div className="flex flex-col gap-3 md:gap-4 w-full px-4 md:px-6 py-6 md:py-8 items-start">
      <Text size={SLIDE_COMPONENT_TITLE_SIZE} className="text-white font-normal mb-2 md:mb-3 text-left uppercase tracking-widest text-sm md:text-lg flex-none">SWOT Analysis</Text>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-3 w-full">
        {sections.map((section, idx) => (
          <div key={idx} className={`p-3 md:p-4 rounded-xl border ${section.color} backdrop-blur-sm bg-black/10 text-left`}>
            <Text size="xs" className="text-white font-normal mb-2 md:mb-3 uppercase tracking-widest block text-left md:text-sm">
              {section.title}
            </Text>
            <ul className="space-y-1.5 md:space-y-2 w-full">
              {section.items.map((item, i) => (
                <li key={i} className="flex gap-2 items-baseline text-left">
                  <span className="opacity-40 text-md md:text-lg flex-none">•</span>
                  <Text size={SLIDE_COMPONENT_TEXT_SIZE} className="text-white/80 leading-relaxed text-left text-xs md:text-md">
                    {item}
                  </Text>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}
